<template>
  <div class="tree-box">
    <el-tree :data="treeData" default-expand-all :expand-on-click-node="false" ref="vueTree" :props="defaultProps">
       <span class="custom-tree-node " slot-scope="{ node, data }">
        <span @click="getResourceList(data)" class="tree-span" :class="{ active: data.id === functionId }">{{ node.label }}</span>
      </span>
    </el-tree>
  </div>
</template>
<script>
export default {
  name: 'tree',
  props: {
    treeData: {
      data: Array
    },
    functionId: {
      data: String,
      default: ''
    }
  },
  data() {
    return {
      defaultProps: {
        children: 'children',
        label: 'label'
      }
    };
  },
  methods: {
    getResourceList(data) {
      this.$emit('getResourceList', {
        functionId: data.id,
        type: data.type
      });
    }
  }
};
</script>
<style lang="scss">
.tree-box {
  .el-tree-node.is-current {
    & > .el-tree-node__content > .custom-tree-node {
      /*color: dodgerblue;*/
    }
  }

  .active {
    color: dodgerblue;
  }

  .el-tree-node:focus > .el-tree-node__content, .el-tree-node:hover > .el-tree-node__content {
    background-color: transparent;
  }

  .tree-span {
    font-size: 14px;
  }
}
</style>
